import widgetTypes from './widget-types';

const PROPERTY_DATA = Symbol('data');

class WidgetDataSource {
    /**
     * Create a dataSource object based on the given widget configuration
     * @param {SankeyTouchpointInfoConfigWidget} widgetConfiguration
     * @returns {WidgetDataSource} DataSource for the given configuration
     */
    static Parse(widgetConfiguration){
        //TODO: More types?
        return new UrlDataSource(widgetConfiguration);
    }

    /**
     * Read the dataSource
     * @return {Promise<*[]>}
     */
    read() {
        //Placeholder implementation
        return Promise.resolve([]);
    }
    
    get data(){
        return this[PROPERTY_DATA] || [];
    }
}

class UrlDataSource extends WidgetDataSource {
    /**
     * Create a dataSource object pulling data from the given URL
     * @param {SankeyTouchpointInfoConfigWidget} widgetConfiguration configuration to use for the dataSource
     */
    constructor(widgetConfiguration) {
        super();
        
        this._url = widgetConfiguration.dataSource;
        this._widgetType = widgetConfiguration.type;
        
        //Importanté, versioning our formats should allow us to change them without affecting live environments
        this._requested_version = 1;
    }
    
    async read() {
        //TODO: Implement URL read
        const data = Promise.resolve(this._getTestData());
        this[PROPERTY_DATA] = data;
        return data;
    }

    get data() {
        return super.data;
    }
    
    _getTestData(){
        if(this._widgetType === widgetTypes.BAR){
            return {
                data: [{
                    'category': 'Start audience',
                    'value': 76000,
                    'percentage': 100
                }, {
                    'category': 'Vorige TP',
                    'value': 56000,
                    'percentage': 89
                }, {
                    'category': 'Aangekomen TP',
                    'value': 23000,
                    'percentage': 39
                }, {
                    'category': 'Overig TP',
                    'value': 19000,
                    'percentage': 12
                }],
                metadata: {
                    categoryColumn: 'category',
                    valueColumn: 'value',
                    percentageColumn: 'percentage'
                }
            };
        } else if (this._widgetType === widgetTypes.DETAILS_TABLE){
            return {
                data: [{
                    'category': 'Start audience',
                    'Apparaat': 'Smartphone',
                    'Aantal abonnees': '23423',
                    'Gemiddelde leeftijd': '34 jaar',
                    'Aantal proeven': '23940'
                }, {
                    'category': 'Vorige TP',
                    'Apparaat': 'Desktop',
                    'Aantal abonnees': '4533',
                    'Gemiddelde leeftijd': '37 jaar',
                    'Aantal proeven': '3455'
                }, {
                    'category': 'Aangekomen TP',
                    'Apparaat': 'Tablet',
                    'Aantal abonnees': '543',
                    'Gemiddelde leeftijd': '32 jaar',
                    'Aantal proeven': '234'
                }, {
                    'Apparaat': 56,
                    'Aantal abonnees': 56,
                    'Gemiddelde leeftijd': -16,
                    'Aantal proeven': -16
                }],
                metadata: {
                    //Only these columns will be included in our table
                    orderedColumns: ['Aantal abonnees', 'Gemiddelde leeftijd', 'Apparaat', 'Aantal proeven'],
                    categoryProperty: 'category'
                }
            }
        }
        
        return [];
    }
}

export default WidgetDataSource;